import React from 'react';

type Props = {
  width?: string;
  height?: string;
};

const SimplePencilIcon = ({ width = '11', height = '11' }: Props) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
    <path
      d="M11.5 1.5l3 3L5 14H2v-3L11.5 1.5z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SimplePencilIcon;
